<template>
    <base-modal v-model="modals.drawing" footerClasses="text-center" size="xl" backdrop="static">

        <canvas class="drawing-canvas" ref="drawingcanvas"
            @pointerdown="beginDrawing"
            @pointermove="keepDrawing"
            @pointerup="stopDrawing"
            @pointerleave="stopDrawing"
            @pointercancel="stopDrawing"
        />

        <template slot="footer">
            <div>
                <base-button type="primary" @click="capture">
                    {{ $t('common.save') }}
                </base-button>

                <base-button type="link" class="ml-auto" @click="close">
                    {{ $t('common.cancel') }}
                </base-button>
            </div>
        </template>
    </base-modal>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'

    export default {

        data() {
            return {
                modals: new ModalsController(['drawing']),

                x: 0,
                y: 0,
                isDrawing: false,
                ctx: null,
            }
        },

        created() {
            this.modals.init(this, 'modals')
        },

        methods: {

            open() {
                this.modals.open('drawing')
            },

            close() {
                this.modals.close('drawing')
            },

            adjustCanvasSize() {
                const canvas = this.$refs.drawingcanvas;
                const rect = canvas.getBoundingClientRect();
                canvas.width = rect.width;
                canvas.height = rect.height;
            },

            getCanvasCoordinates(event) {
                const rect = event.target.getBoundingClientRect();
                const scaleX = event.target.width / rect.width;
                const scaleY = event.target.height / rect.height;
                return {
                    x: (event.clientX - rect.left) * scaleX,
                    y: (event.clientY - rect.top) * scaleY
                };
            },

            drawLine(x1, y1, x2, y2) {
                this.ctx.beginPath();
                this.ctx.strokeStyle = 'black';
                this.ctx.lineWidth = 2;
                this.ctx.moveTo(x1, y1);
                this.ctx.lineTo(x2, y2);
                this.ctx.stroke();
                this.ctx.closePath();
            },

            beginDrawing(event) {
                if (!this.ctx) {
                    this.adjustCanvasSize()
                    this.ctx = this.$refs.drawingcanvas.getContext('2d')
                }
                const { x, y } = this.getCanvasCoordinates(event)
                this.x = x
                this.y = y
                this.isDrawing = true
            },

            keepDrawing(event) {
                if (this.isDrawing) {
                    const { x, y } = this.getCanvasCoordinates(event);
                    this.drawLine(this.x, this.y, x, y);
                    this.x = x;
                    this.y = y;
                }
            },

            stopDrawing(event) {
                if (this.isDrawing) {
                    const { x, y } = this.getCanvasCoordinates(event);
                    this.drawLine(this.x, this.y, x, y);
                    this.isDrawing = false;
                }
            },

            capture() {
                const canvas = this.$refs.drawingcanvas;
                const url = canvas.toDataURL("image/png");

                canvas.toBlob((blob) => {

                    const file = new File([blob], "image.png", { type: "image/png" });

                    // File input.
                    const dataTransfer = new DataTransfer();
                    dataTransfer.items.add(file);

                    this.$emit('addedfile', { file, url, from: 'drawing' })

                    this.close()

                }, "image/png", 0.95);
            },

            reset() {
                const canvas = this.$refs.drawingcanvas;
                const ctx = canvas.getContext('2d')
                ctx.clearRect(0, 0, canvas.width, canvas.height)
            },
        },
    }
</script>

<style scoped>

    .drawing-canvas {
        width: 100%;
        height:auto;
        border: 1px solid #dee2e6;
        touch-action: none;      /* critical on mobile */
        -ms-touch-action: none;  /* old Edge */
    }

</style>
